export const CompanyType = {
    LLP: { value: "0", name: "LLP", color: "danger" },
    PRIVATE: { value: "1", name: "Private Limited (PVT)", color: "success" },
    LISTED: { value: "2", name: "Listed", color: "success" },
    GOVT: { value: "3", name: "Government", color: "success" },
    OTHERS: { value: "4", name: "Other", color: "success" },
};

export interface CompanySearch {
    search: string;
    type: string;
    searchType: string;
}

export interface CompanySelect {
    companyName: string;
    companyType: string;
    companyId: string;
    searchType: string;
    companyTypeNew: string;
}

export interface EmploymentDataPayload {
    companyId: number;
    companyName: string;
    companyType: string;
    companyAddress: any;
    companyWebsite: any;
    salaryRange: string;
}

export enum CompanySearchType {
    ELASTIC = "0",
    DB = "1",
    THIRD = "2",
}
export interface EmploymentDraft {
    companyAddress?: string;
    companyPhone?: string;
    companyWebsite?: string;
    salary?: string | number;
    salaryDay?: string | number;
}

export interface AddressDetails {
    address: string;
    city: string;
    district: string;
    latitude: number;
    longitude: number;
    name: string;
    pinCode: string;
    placeId: string;
    state: string;
}

export const CompanySize = {
    MSME: { value: "0", name: "MSME", color: "danger" },
    LARGE: { value: "1", name: "Large", color: "success" },
};

export const SalaryRange = {
    RANGE_BELOW_30K: { value: "0", name: "Below ₹30,000" },
    RANGE_30K_50K: { value: "1", name: "₹30,000 - ₹50,000" },
    RANGE_50K_75K: { value: "2", name: "₹50,001 - ₹75,000" },
    RANGE_75K_PLUS: { value: "3", name: "Above ₹75,000" },
};
